var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.293,
    height: 105.08,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#050101",
      strokeWidth: 1.027,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M80.99.68a20.114 20.114 0 0 0-19.383 14.83 13.5 13.5 0 0 0-2.457-.235c-7.453 0-13.493 6.043-13.494 13.496 0 2.133.509 4.18 1.39 6.026H3.829V53.73h86.213V42.7h13.71c7.793-.491 13.862-7.516 13.862-15.323 0-8.17-6.624-14.792-14.793-14.791a14.72 14.72 0 0 0-3.318.396A20.113 20.113 0 0 0 80.99.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 1.02673626,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M3.827 34.797H90.04V53.73H3.827Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 1.02673626,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M9.102 41.747h14.813v4.273H9.102zm18.089 0h14.813v4.273H27.191zm51.862 0h6.312v4.273h-6.312zM3.827 59.245H90.04V78.18H3.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 1.02673626,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M9.102 66.196h14.813v4.273H9.102zm18.089 0h14.813v4.273H27.191zm51.862 0h6.312v4.273h-6.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.38716173,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M46.934 53.832v5.237m0 19.212v19.354"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000405",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.38570905,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M41.999 94.017h9.87v9.87h-9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.38716173,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M0 98.953h93.867"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBw);
export default __webpack_public_path__ + "static/media/CloudBW.64027913934f6cea724411bf898e89c0.svg";
export { ForwardRef as ReactComponent };